import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

interface WrapperProps extends BoxProps {
  withPadding?: boolean;
}

const Wrapper: React.FC<WrapperProps> = ({
  children,
  withPadding = true,
  ...props
}) => (
  <Box
    flex={1}
    backgroundColor="white"
    borderRadius="xl"
    boxShadow="base"
    p={withPadding ? { base: 6, lg: 8 } : 0}
    {...props}
  >
    {children}
  </Box>
);

export default Wrapper;
